import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = ["id"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 0,
    style: { "float": "right" },
    class: "text-muted"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tooltip = _resolveComponent("Tooltip");
    return (_ctx.isTopLevel)
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createElementVNode("a", {
                class: "nav-link",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.runFunction(_ctx.menuData)))
            }, _toDisplayString(_ctx.menuData.text), 1)
        ]))
        : (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createVNode(_component_Tooltip, {
                tip: _ctx.introductionTxt(_ctx.menuData.pluginId),
                placement: "right"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("a", {
                        class: _normalizeClass('dropdown-item pt-0' + (_ctx.disabled ? ' disabled' : '')),
                        style: { "padding-bottom": "2px", "pointer-events": "all" },
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.runFunction(_ctx.menuData))),
                        id: 'menu-plugin-' + _ctx.idSlug
                    }, [
                        _createElementVNode("span", {
                            innerHTML: _ctx.menuData.text?.replace("_", "")
                        }, null, 8, _hoisted_4),
                        (_ctx.showHotkey)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.hotkeyPrefix) + _toDisplayString(_ctx.hotkeyToShow(_ctx.menuData)), 1))
                            : _createCommentVNode("", true)
                    ], 10, _hoisted_3)
                ]),
                _: 1
            }, 8, ["tip"])
        ]));
}
